export enum MapViewEvent {
  render = 'render',
  toggleFullscreen = 'toggleFullscreen',
  enterFullscreen = 'enterFullscreen',
  exitFullscreen = 'exitFullscreen',
  toggleShowMap = 'toggleShowMap',
}
